module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-user"
  }, [(_vm.step < 2) ? _c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Invite new user to Clear Assured")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [(_vm.step < 2) ? _c('router-link', {
    staticClass: "dashboard background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")]) : _vm._e(), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3)) ? _c('button', {
    staticClass: "add-users background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.inviteNewUsers()
      }
    }
  }, [_vm._v("Invite new users")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "all-users",
    attrs: {
      "to": {
        name: _vm.getUserRole === 'gm' ? 'users' : 'ca-users'
      }
    }
  }, [_vm._v("Back to all users list")])], 1), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [((_vm.inviteType === 1 && _vm.step === 0) || (_vm.inviteType === 2 && _vm.currentStepImport === 0)) ? [_vm._v("\n            Step 1: invite new users\n          ")] : ((_vm.inviteType === 2 && _vm.currentStepImport === 1)) ? [_vm._v("\n            Step 2: Sync csv columns\n          ")] : (_vm.inviteType === 1 && _vm.step === 1) ? [_vm._v("\n            Step 2: complete user profiles\n            "), _c('span', {
    staticClass: "hide-desktop"
  }, [_vm._v("\n              (" + _vm._s(_vm.userInvites.length) + " "), (_vm.userInvites.length === 1) ? [_vm._v("user")] : [_vm._v("users")], _vm._v(")\n            ")], 2)] : (_vm.inviteType === 2 && _vm.currentStepImport === 2) ? [_vm._v("\n            Step 3: complete user profiles\n            "), _c('span', {
    staticClass: "hide-desktop"
  }, [_vm._v("\n              (" + _vm._s(_vm.userInvites.length) + " "), (_vm.userInvites.length === 1) ? [_vm._v("user")] : [_vm._v("users")], _vm._v(")\n            ")], 2)] : [_vm._v("\n            Users status\n          ")]], 2), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 0) || (_vm.inviteType === 2 && _vm.currentStepImport === 0)) ? _c('p', {
    staticClass: "content-section-description"
  }, [_vm._v("\n          Add the email addresses of the people you want to invite to use Clear Assured in the Email box below,\n          you can add up to 500 users. Select the user role that you want to assign to these users.\n          You can amend the role on the next page if they are not all the same.\n        ")]) : _vm._e(), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 0) || (_vm.inviteType === 2 && _vm.currentStepImport === 0)) ? _c('div', {
    staticClass: "invite-users-methods"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-control form-control__radio"
  }, [_c('input', {
    attrs: {
      "id": "invite-users-by-paste",
      "type": "radio",
      "name": "invite-type"
    },
    domProps: {
      "checked": _vm.inviteType === 1
    },
    on: {
      "change": function($event) {
        return _vm.changeInviteType(1)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "invite-users-by-paste"
    }
  }, [_vm._v("Paste emails")])]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-control__radio"
  }, [_c('input', {
    staticClass: "form-control form-control__radio",
    attrs: {
      "id": "invite-users-by-csv",
      "type": "radio",
      "name": "invite-type"
    },
    domProps: {
      "checked": _vm.inviteType === 2
    },
    on: {
      "change": function($event) {
        return _vm.changeInviteType(2)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "invite-users-by-csv"
    }
  }, [_vm._v("Import CSV file")])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 0 && _vm.inviteType === 1) ? [_c('div', {
    staticClass: "form-group-ninth"
  }, [_c('div', {
    staticClass: "form-group form-group-half invite-emails-container"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-emails"
    }
  }, [_vm._v("\n                  Email addresses\n                  "), (_vm.userInvites.length) ? _c('button', {
    staticClass: "invite-emails-clear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearAllEmails()
      }
    }
  }, [_vm._v("Clear all")]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "emailsAddWrapper",
    staticClass: "invite-emails-wrapper",
    class: [{
      'active': _vm.userInvites.length
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.inputEmails.focus()
      }
    }
  }, [_vm._l((_vm.userInvites), function(item, index) {
    return _c('div', {
      staticClass: "invite-emails-item",
      class: [{
        'error': !item.isValid
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeEmail($event, index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.email) + "\n                    "), _c('button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeEmail(index, 0)
        }
      }
    })])
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.input),
      expression: "email.input"
    }],
    ref: "inputEmails",
    staticClass: "invite-emails-input",
    staticStyle: {
      "white-space": "nowrap",
      "overflow": "hidden"
    },
    attrs: {
      "cols": "20",
      "rows": "1",
      "data-lpignore": "true",
      "id": "new-user-emails"
    },
    domProps: {
      "value": (_vm.email.input)
    },
    on: {
      "blur": function($event) {
        return _vm.createTags($event)
      },
      "paste": function($event) {
        _vm.email.isPaste = true
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "input", $event.target.value)
      }, function($event) {
        return _vm.createTags($event, true)
      }],
      "keydown": function($event) {
        return _vm.emailsKeyDown($event)
      }
    }
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-role"
    }
  }, [_vm._v("User type")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getRolesForSelect,
      "data-lpignore": "true",
      "id": "new-user-company-role"
    },
    model: {
      value: (_vm.defaultRole),
      callback: function($$v) {
        _vm.defaultRole = $$v
      },
      expression: "defaultRole"
    }
  })], 1), _vm._v(" "), ((_vm.defaultRole === null || (_vm.defaultRole && _vm.defaultRole.slug !== 'gm')) && _vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": true,
      "options": _vm.getCompaniesForSelect,
      "data-lpignore": "true",
      "id": "new-user-company"
    },
    model: {
      value: (_vm.defaultCompany),
      callback: function($$v) {
        _vm.defaultCompany = $$v
      },
      expression: "defaultCompany"
    }
  })], 1) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.currentStepImport === 0 && _vm.inviteType === 2) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "invite-users-upload-file"
  }, [_c('div', {
    staticClass: "choose-file-wrapper"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "fileInput"
    },
    on: {
      "change": function($event) {
        return _vm.convertFile($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "choose-file"
  }, [_vm._v("choose file")])]), _vm._v(" "), _c('span', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.fileName))]), _vm._v(" "), (_vm.usersImported) ? _c('button', {
    staticClass: "upload-file",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(2)
      }
    }
  }, [_vm._v("upload CSV file")]) : _vm._e()])] : ((_vm.inviteType === 1 && (_vm.step === 1 || _vm.step === 2)) || (_vm.inviteType === 2 && (_vm.currentStepImport === 2 || _vm.currentStepImport === 3))) ? [_c('div', {
    staticClass: "invite-emails-list",
    class: [{
      'server-response': (_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3),
      'is-admin': _vm.getUserRole === 'gm'
    }, 'step-' + _vm.step]
  }, [(_vm.requestInProcess) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.userInvites), function(item, index) {
    return _c('div', {
      staticClass: "form-group",
      class: [{
        'error': (_vm.inviteType === 1 && _vm.step === 2 && _vm.response[item.id].code > 0) || (_vm.inviteType === 2 && _vm.currentStepImport === 3 && _vm.response[item.id].code > 0)
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.id = index),
        expression: "item.id = index"
      }],
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (item.id = index)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "id = index", $event.target.value)
        }
      }
    }), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3)) ? _c('div', {
      staticClass: "form-element status"
    }, [_c('span', {
      class: [{
        'error': _vm.response[item.id].code > 0
      }]
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-element email"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-email-' + index
      }
    }, [_vm._v("Email")]), _vm._v(" "), _c('textarea', {
      staticClass: "form-control form-control__textarea",
      class: [{
        'error': !item.isValid,
        'active': item.email
      }],
      attrs: {
        "data-lpignore": "true",
        "data-gramm_editor": "false",
        "id": 'user-invite-email-' + index
      },
      on: {
        "input": function($event) {
          return _vm.changeValid(item, $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.email))])]), _vm._v(" "), _c('div', {
      staticClass: "form-element role"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-type-' + index
      }
    }, [_vm._v("User type")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
      class: [{
        'active': item.role,
        'has-error': _vm.userHasError('role', item)
      }],
      attrs: {
        "searchable": false,
        "on-change": _vm.roleChanged(item),
        "options": _vm.getRolesForSelect,
        "data-lpignore": "true",
        "name": "User type",
        "id": 'user-invite-type-' + index
      },
      model: {
        value: (item.role),
        callback: function($$v) {
          _vm.$set(item, "role", $$v)
        },
        expression: "item.role"
      }
    })], 1), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
      staticClass: "form-element company"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-company-' + index
      }
    }, [_vm._v("Company")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
      class: [{
        'active': item.company,
        'is-blocked': item.role && item.role.slug === 'gm',
        'has-error': _vm.userHasError('company', item)
      }],
      attrs: {
        "disabled": item.role && item.role.slug === 'gm',
        "searchable": true,
        "options": _vm.getCompaniesForSelect,
        "data-lpignore": "true",
        "id": 'user-invite-company-' + index
      },
      model: {
        value: (item.company),
        callback: function($$v) {
          _vm.$set(item, "company", $$v)
        },
        expression: "item.company"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-element title"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-title-' + index
      }
    }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      class: [{
        'active': item.title,
        'is-blocked': item.role && item.role.slug === 'gm'
      }],
      attrs: {
        "type": "text",
        "disabled": item.role && item.role.slug === 'gm',
        "data-lpignore": "true",
        "id": 'user-invite-title-' + index
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element function"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-title-' + index
      }
    }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.function),
        expression: "item.function"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      class: [{
        'active': item.function,
        'is-blocked': item.role && item.role.slug === 'gm'
      }],
      attrs: {
        "type": "text",
        "disabled": item.role && item.role.slug === 'gm',
        "data-lpignore": "true",
        "id": 'user-invite-function-' + index
      },
      domProps: {
        "value": (item.function)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "function", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element firstname"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-first-name-' + index
      }
    }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.firstName),
        expression: "item.firstName"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'active': item.firstName
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": 'user-invite-first-name-' + index
      },
      domProps: {
        "value": (item.firstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "firstName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element lastname"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-last-name-' + index
      }
    }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.lastName),
        expression: "item.lastName"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'active': item.lastName
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": 'user-invite-last-name-' + index
      },
      domProps: {
        "value": (item.lastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "lastName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element phone"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-phone-' + index
      }
    }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.phone),
        expression: "item.phone"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'active': item.phone
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": 'user-invite-phone-' + index
      },
      domProps: {
        "value": (item.phone)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "phone", $event.target.value)
        }
      }
    })]), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 1) || (_vm.inviteType === 2 && _vm.currentStepImport === 2)) ? _c('div', {
      staticClass: "form-element remove"
    }, [_c('a', {
      staticClass: "invite-emails-remove",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeEmail(index, 1)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (!item.isValid || (_vm.step === 2 && _vm.response[item.id].code > 0) || (_vm.currentStepImport === 3 && _vm.response[item.id].code > 0) || _vm.userHasError('role', item) || _vm.userHasError('company', item)) ? _c('div', {
      staticClass: "invite-emails-error",
      class: [{
        'step2': (_vm.inviteType === 1 && _vm.step === 2) || _vm.inviteType === 2 && _vm.currentStepImport === 3
      }]
    }, [(!item.isValid || (_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3)) ? [((_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3)) ? [(_vm.response[item.id].code === 2) ? [_vm._v("\n                      We were unable to send an email to this address. Please make sure you typed it correctly.\n                      If you need assistance, please send us an email at support.team@clearassured.co.uk.\n                    ")] : (_vm.response[item.id].code === 3) ? [_vm._v("\n                      This user was not invited - the email we sent was marked as spam by the receipient server and rejected.\n                      Please make sure you typed it correctly. If you need assistance, please send us an email at support.team@clearassured.co.uk.\n                    ")] : (_vm.response[item.id].code === 4) ? [_vm._v("\n                      We couldn't send an invite - this user is already in our system.\n                    ")] : (_vm.response[item.id].code === 5) ? [_vm._v("\n                      We encountered an error processing your request - we couldn't associate this user with a company.\n                      Please try again and if the problem persists, get in touch with the website developers.\n                    ")] : (_vm.response[item.id].code === 6) ? [_vm._v("\n                      We couldn't invite this user. The domain of the email address you used is not approved for your organization.\n                    ")] : (_vm.response[item.id].code === 7) ? [(_vm.getUserRole === 'ca') ? [_vm._v("\n                        Users limit exceeded - your plan supports up to " + _vm._s(_vm.user.company.employee_limit) + " active users.\n                      ")] : [_vm._v("\n                        Users limit exceeded - " + _vm._s(item.company.label) + " plan supports up to " + _vm._s(item.company.usersLimit) + " active users.\n                      ")]] : [_vm._v("\n                      We encountered an error processing your request. Some mandatory fields are missing or are filled in wrong.\n                      Please try again and if the problem persists, get in touch with the website developers.\n                    ")]] : [_vm._v("\n                    Wrong email format. Please use a valid email address (e.g. name@domain.tld).\n                  ")]] : _vm._e(), _vm._v(" "), (_vm.userHasError('role', item)) ? [_c('p', [_vm._v("User type is mandatory field")])] : _vm._e(), _vm._v(" "), (_vm.userHasError('company', item)) ? [_c('p', [_vm._v("Company is mandatory field")])] : _vm._e()], 2) : _vm._e()])
  }), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 2 && _vm.status) || (_vm.inviteType === 2 && _vm.currentStepImport === 3 && _vm.status)) ? _c('div', {
    staticClass: "invite-emails-status"
  }, [(_vm.status.success) ? _c('p', {
    staticClass: "success"
  }, [(_vm.status.success === 1) ? [_vm._v("\n                  1 user was successfully invited. "), _c('span', [_vm._v("Invitation link expires after 30 days.")])] : [_vm._v("\n                  " + _vm._s(_vm.status.success) + " users were successfully invited. "), _c('span', [_vm._v("Invitation link expires after 30 days.")])]], 2) : _vm._e(), _vm._v(" "), (_vm.status.error) ? _c('p', {
    staticClass: "error"
  }, [(_vm.status.error === 1) ? [_vm._v("\n                  1 user was not invited.\n                ")] : [_vm._v("\n                  " + _vm._s(_vm.status.error) + " users were not invited.\n                ")]], 2) : _vm._e()]) : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (_vm.inviteType === 2 && _vm.currentStepImport === 1) ? [_c('div', {
    staticClass: "invite-emails-list from-import"
  }, [_c('div', {
    staticClass: "flex-block"
  }, _vm._l((_vm.csvData), function(col) {
    return _c('div', {
      staticClass: "form-element"
    }, [_c('v-select', {
      staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
      class: [{
        'valid': col.column.value !== 'skip'
      }],
      attrs: {
        "searchable": false,
        "options": _vm.columns,
        "placeholder": "Skip this column",
        "data-lpignore": "true"
      },
      model: {
        value: (col.column),
        callback: function($$v) {
          _vm.$set(col, "column", $$v)
        },
        expression: "col.column"
      }
    }), _vm._v(" "), _vm._l((col.items), function(item, i) {
      return _c('div', {
        staticClass: "form-info email",
        attrs: {
          "hidden": _vm.ignoreFirstRow && i === 0
        }
      }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "invite-users-ignore-first"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    staticClass: "form-control form-control__checkbox",
    attrs: {
      "id": "invite-users-ignore-first",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.ignoreFirstRow
    },
    on: {
      "change": function($event) {
        return _vm.changeIgnoreFirst()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "invite-users-ignore-first"
    }
  }, [_vm._v("Don't import first row")])])])])])] : _vm._e()], 2)]), _vm._v(" "), (_vm.step === 1 || _vm.currentStepImport === 2) ? _c('div', {
    staticClass: "invite-emails-info hide-desktop"
  }, [_vm._v("List contains " + _vm._s(_vm.userInvites.length) + "\n      "), (_vm.userInvites.length === 1) ? [_vm._v("\n        user.\n      ")] : [_vm._v("\n        users.\n      ")]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.inviteType === 2 && _vm.currentStepImport === 1) ? _c('div', {
    staticClass: "add-new-user-control-panel"
  }, [_c('button', {
    staticClass: "submit-user",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(2)
      }
    }
  }, [_vm._v("\n        Next\n      ")])]) : _vm._e(), _vm._v(" "), ((_vm.inviteType === 1 && (_vm.step === 0 || _vm.step === 1)) || (_vm.inviteType === 2 && _vm.currentStepImport === 2)) ? _c('div', {
    staticClass: "add-new-user-control-panel"
  }, [_c('button', {
    staticClass: "submit-user",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(3)
      }
    }
  }, [(_vm.inviteType === 1) ? [_vm._v("\n          Next\n        ")] : [_vm._v("\n          Send invitations\n        ")]], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invite-users-upload-info"
  }, [_vm._v("\n            Please "), _c('a', {
    attrs: {
      "href": "/import-users-sample.csv",
      "download": ""
    }
  }, [_vm._v("download our CSV sample")]), _vm._v(", fill in your data and upload it here.\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ef11a28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AddUser.vue
// module id = 917
// module chunks = 1